import { render, staticRenderFns } from "./Editar_Personales.vue?vue&type=template&id=0fe1286c&"
import script from "./Editar_Personales.vue?vue&type=script&lang=js&"
export * from "./Editar_Personales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/laragon/www/front-panel-docentes/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn})
